// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1HMJA","title":"Images90_title__21uJ-","images":"Images90_images__3AI76"};